import { InjectionToken } from '@angular/core';
export const DATE_FORMAT = new InjectionToken<string>('DATE_FORMAT');
export const PCNT_FORMAT = new InjectionToken<string>('PCNT_FORMAT');

export const defaultDateFormat = 'dd-MMM-yyyy';
export const defaultPcntFormat = '2';
